import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Modules
import { NgMaterialModule } from './core/ng/material.module';
import { AppRoutingModule } from './app-routing.module';
import { TreeModule } from 'angular-tree-component';

// Redux
import { NgRedux, NgReduxModule } from '@angular-redux/store';
import { IAppState, rootReducer, INITIAL_STATE } from './core/store/store';

// Services
import { UserService } from './user/service/user.service';
import { UserRouteGuard } from './user/service/user.routeguard';
import { UserDatahubService } from './user/service/user-datahub.service';
import { MaengelDatahubService } from './maengel/service/maengel-datahub.service';
import { NavigationDatahubService } from './nav/service/navigation-datahub.service';
import { AppUserMessageService } from './core/library/app-user-message/app-user-message.service';
import { UiMessageSnackService } from './core/components/message-snack/service/message-snack.service';
import { NavigationService } from './nav/service/navigation.service';

// JSON schema form
import { GroupComponent } from './core/json-form/material/group/group.component';
import { StringComponent } from './core/json-form/material/string/string.component';
import { CheckboxComponent } from './core/json-form/material/checkbox/checkbox.component';
import { SelectComponent } from './core/json-form/material/select/select.component';
import { NumberComponent } from './core/json-form/material/number/number.component';
import { LayoutComponent } from './core/json-form/material/layout/layout.component';
import { JsonFormComponent } from './core/json-form/material/json-form-root/json-form-root.component';
import { JsonFormViewComponent } from './core/json-form/material/json-form-view/json-form-view.component';

// compc Components
import { JsonFormContComponent } from './json-form/compc/json-form-cont/json-form-cont.component';
import { MaengelContComponent } from './maengel/compc/maengel-cont/maengel-cont.component';
import { NavContComponent } from './nav/compc/nav-cont/nav-cont.component';

// entry Components
import { AppUserMessageComponent } from './core/library/app-user-message/app-user-message.component';

// compv Components
import { TopmenuComponent } from './menu/topmenu/topmenu.component';
import { SignInViewComponent } from './user/compv/signin-view/signin-view.component';
import { MaengellisteViewComponent } from './maengel/compv/maengelliste-view/maengelliste-view.component';
import { MaengeldetailMdlgComponent } from './maengel/compv/maengeldetail-mdlg/maengeldetail-mdlg.component';
import { LoadingPopupComponent } from './core/components/loading-popup/loading-popup.component';
import { NavGraph1Component } from './nav/compv/nav-graph1/nav-graph1';
import { NavTreeComponent } from './nav/compv/nav-tree/nav-tree';
import { NavElemDetailComponent } from './nav/compv/nav-elem-detail-view/nav-elem-detail-view.component';
import { MessageSnackComponent } from './core/components/message-snack/message-snack.component';
import { BreadcrumbComponent } from './core/components/breadcrumb/breadcrumb.component';
import { TopmenuNavSearchComponent } from './nav/compv/topmenu-nav-search/topmenu-nav-search.component';
import { TopmenuNavSearchContComponent } from './nav/compc/topmenu-nav-search-cont/topmenu-nav-search-cont.component';
import { NavGraphViewOptionsComponent } from './nav/compv/nav-graph-view-options/nav-graph-view-options';
import { BreadcrumbContComponent } from './core/components/breadcrumb/breadcrumb-cont.component';
import { NavGraph2MdlgComponent } from './nav/compv/nav-graph2-mdlg/nav-graph2-mdlg';
import { NavGraph2Component } from './nav/compv/nav-graph2/nav-graph2';
import { ConfirmDialogComponent } from './core/components/confirm-dialog/confirm-dialog';
import { ConfirmDialogsService } from './core/components/confirm-dialog/service/confirm-dialog.service';
import { NavCreateElement2Component } from './nav/compv/nav-create-element2/nav-create-element2';
import { CreateElementService } from './nav/service/create-element.service';
import { LoadingphaseService } from './nav/service/loadingphase.service';
import { CheckRoleDirective } from './user/directive/check-role.directive';
import { SubmitIfValidDirective } from './core/directives/submit-if-valid.directive';
import { ChangePasswordCardComponent } from './user/compv/change-password-card/change-password-card.component';
import { TreeDataServiceService } from './nav/service/tree-data-service.service';
import { DatePipe } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DtbSelectPopupComponent } from './menu/dtb-select-popup/dtb-select-popup.component';
import { FgSelectPopupComponent } from './menu/fg-select-popup/fg-select-popup.component';

@NgModule({
  declarations: [
    AppComponent,

    // View Components
    TopmenuComponent,
    SignInViewComponent,

    JsonFormContComponent,
    JsonFormViewComponent,
    GroupComponent,
    StringComponent,
    CheckboxComponent,
    SelectComponent,
    NumberComponent,
    LayoutComponent,
    JsonFormComponent,
    MaengellisteViewComponent,
    MaengelContComponent,
    MaengeldetailMdlgComponent,
    LoadingPopupComponent,
    NavContComponent,
    NavGraph1Component,
    NavTreeComponent,
    NavElemDetailComponent,
    AppUserMessageComponent,
    MessageSnackComponent,
    BreadcrumbComponent,
    NavGraphViewOptionsComponent,
    TopmenuNavSearchComponent,
    TopmenuNavSearchContComponent,
    BreadcrumbContComponent,
    NavGraph2MdlgComponent,
    NavGraph2Component,
    NavCreateElement2Component,
    ConfirmDialogComponent,
    ChangePasswordCardComponent,
    CheckRoleDirective,
    SubmitIfValidDirective,
    DtbSelectPopupComponent,
    FgSelectPopupComponent,
  ],
  entryComponents: [
    AppUserMessageComponent,
    ConfirmDialogComponent,
    NavCreateElement2Component,
    DtbSelectPopupComponent,
    FgSelectPopupComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgMaterialModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule,
    NgReduxModule,
    TreeModule,
    FormsModule,
    MatProgressSpinnerModule,
  ],
  providers: [
    UserService,
    UserRouteGuard,
    UserDatahubService,
    MaengelDatahubService,
    NavigationDatahubService,
    AppUserMessageService,
    UiMessageSnackService,
    LoadingphaseService,

    DatePipe,

    // navigation
    NavigationService,
    TreeDataServiceService,

    // dialogs
    ConfirmDialogsService,
    CreateElementService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(ngRedux: NgRedux<IAppState>) {
    ngRedux.configureStore(rootReducer, INITIAL_STATE);
  }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/app.module.ts